<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ cardTitle }}</div>
            <v-card-text v-if="!posted">
                <v-form ref="surveyForm" v-model="valid" lazy-validation>

                    <v-row>
                        <v-col cols="12">
                            <v-card tile class="mt-4 elevation-0" color="grey lighten-5" style="border: 3px solid var(--v-secondary-base) !important">
                                <div class="text-center">

                                    <span style="float:left">
                                        <v-tooltip bottom v-if="question.questionTypeId">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn small fab class="ma-3" v-bind="attrs" v-on="on" @click="selectedQuestionTypeId = question.questionTypeId; previewDialog = true ">
                                                    <v-icon color="primary">
                                                        mdi-eye
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ $t('Preview') }}</span>
                                        </v-tooltip>

                                    </span>
                                </div>

                                <v-card-text class="pt-8" style="clear:both">
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-0">
                                            <v-text-field dense outlined v-model.lazy="question.questionAr" @change="handleCopyValue('question.questionAr', 'question.questionEn')" append-icon="mdi-comment-question-outline" :rules="nameRules" :label="$t('QuestionAr')" />
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-0">
                                            <v-text-field dense outlined v-model.lazy="question.noteAr" append-icon="mdi-comment-outline" :label="$t('NoteAr')" />
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6" class="py-0" style="display:none">
                                            <v-text-field dense outlined v-model.lazy="question.questionEn" append-icon="mdi-comment-question-outline" :label="$t('QuestionEn')" />
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-0" style="display:none">
                                            <v-text-field dense outlined v-model.lazy="question.noteEn" append-icon="mdi-comment-outline" :label="$t('NoteEn')" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="10" class="py-0">
                                            <v-autocomplete searchable dense outlined v-model.lazy="question.questionTypeId" :items="questionTypes" :menu-props="{ bottom: true, offsetY: true }" :rules="nameRules" append-icon="mdi-chevron-down" item-value="id" item-text="questionTypeNameEn" :label="$t('Select')" @change="changeQuestionType(question, $event)">
                                                <template v-slot:item="{ item }">
                                                    <v-icon class="me-2" color="primary">{{ item.iconMdi }}</v-icon>
                                                    <v-list-item-content>
                                                        <h4>{{ language == 'ar' ?  item.questionTypeNameAr: item.questionTypeNameEn }}</h4>
                                                    </v-list-item-content>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="2" class="text-center py-0">
                                            <v-checkbox v-model.lazy="question.isRequired" :label="$t('Required')" class="ma-2 mx-4"></v-checkbox>
                                        </v-col>
                                    </v-row>


                                </v-card-text>
                                <v-card-actions>
                                    <v-expansion-panels class="mb-4">
                                        <v-expansion-panel key="panel1">
                                            <v-expansion-panel-header background-color="#fefefe">
                                                <b>{{ $t('Settings') }}</b>

                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <!--TextEditor-->
                                                <div v-if="question.questionTypeId == textEditor" class="container">
                                                    <TextEditor />
                                                </div>
                                                <!--shortAnswer textArea-->
                                                <v-text-field class="mt-3" v-if="question.questionTypeId == shortAnswer || question.questionTypeId == textArea" outlined v-model.lazy="question.default" hide-detail dense :label="$t('DefaultText')" />

                                                <!--YesNo-->
                                                <LikeDislike v-if="question.questionTypeId == yesNo"></LikeDislike>

                                                <!--BipolarMatrix-->
                                                <bipolar-matrix v-if="question.questionTypeId == bipolarMatrix" :label="$t('BipolarMatrix')" v-model="question.questions"></bipolar-matrix>

                                                <!--Image-->
                                                <div class="text-center mt-3" v-if="question.questionTypeId == image">
                                                    <v-row>
                                                        <v-col cols="12" sm="12" md="6">
                                                            <!-- File input for image selection -->
                                                            <input 
                                                                type="file"
                                                                accept="image/*"
                                                                @change="onImageFileChange($event, question)"
                                                                :ref="'fileInput_' + question.id"
                                                                style="display: none"
                                                            />
                                                            
                                                            <v-btn rounded class="my-2" outlined @click="$refs['fileInput_' + question.id][0].click()">
                                                                <v-icon size="20" class="me-3">mdi-upload</v-icon>
                                                                {{$t('Upload')}}
                                                            </v-btn>

                                                            <!-- Image Cropper Dialog -->
                                                            <v-dialog v-model="question.showCropper" max-width="900px" persistent>
                                                                <v-card>
                                                                    <v-card-title class="primary white--text">
                                                                        <v-icon color="white" class="me-2">mdi-crop</v-icon>
                                                                        {{$t('CropImage')}}
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn icon dark @click="closeCropper(question)">
                                                                            <v-icon>mdi-close</v-icon>
                                                                        </v-btn>
                                                                    </v-card-title>
                                                                    <v-card-text class="pt-4">
                                                                        <cropper
                                                                            v-if="question.cropperImage"
                                                                            :src="question.cropperImage"
                                                                            :stencil-props="{
                                                                                aspectRatio: NaN,
                                                                                movable: true,
                                                                                resizable: true
                                                                            }"
                                                                            :canvas="{
                                                                                maxWidth: 1920,
                                                                                maxHeight: 1920
                                                                            }"
                                                                            :ref="'cropper_' + question.id"
                                                                            class="cropper-wrapper"
                                                                        />
                                                                        
                                                                        <!-- Zoom Control -->
                                                                        <v-row class="mt-4 align-center">
                                                                            <v-col cols="12">
                                                                                <v-subheader class="px-0">
                                                                                    <v-icon class="me-2">mdi-magnify</v-icon>
                                                                                    {{$t('Zoom')}}
                                                                                </v-subheader>
                                                                                <v-slider
                                                                                    v-model="question.cropperZoom"
                                                                                    @input="onZoomChange(question)"
                                                                                    :min="0"
                                                                                    :max="2"
                                                                                    :step="0.01"
                                                                                    prepend-icon="mdi-magnify-minus"
                                                                                    append-icon="mdi-magnify-plus"
                                                                                    hide-details
                                                                                ></v-slider>
                                                                            </v-col>
                                                                        </v-row>

                                                                        <!-- Rotation Controls -->
                                                                        <v-row class="mt-2 align-center">
                                                                            <v-col cols="12">
                                                                                <v-subheader class="px-0">
                                                                                    <v-icon class="me-2">mdi-rotate-right</v-icon>
                                                                                    {{$t('Rotate')}}
                                                                                </v-subheader>
                                                                                <v-btn-toggle v-model="question.rotationAngle" mandatory class="d-flex flex-wrap">
                                                                                    <v-btn small @click="rotateImage(question, -90)">
                                                                                        <v-icon>mdi-rotate-left</v-icon>
                                                                                        <span class="ms-1">-90°</span>
                                                                                    </v-btn>
                                                                                    <v-btn small @click="rotateImage(question, 90)">
                                                                                        <v-icon>mdi-rotate-right</v-icon>
                                                                                        <span class="ms-1">+90°</span>
                                                                                    </v-btn>
                                                                                    <v-btn small @click="flipImageHorizontal(question)">
                                                                                        <v-icon>mdi-flip-horizontal</v-icon>
                                                                                        <span class="ms-1">{{$t('FlipH')}}</span>
                                                                                    </v-btn>
                                                                                    <v-btn small @click="flipImageVertical(question)">
                                                                                        <v-icon>mdi-flip-vertical</v-icon>
                                                                                        <span class="ms-1">{{$t('FlipV')}}</span>
                                                                                    </v-btn>
                                                                                    <v-btn small @click="resetCropper(question)" color="warning">
                                                                                        <v-icon>mdi-restore</v-icon>
                                                                                        <span class="ms-1">{{$t('Reset')}}</span>
                                                                                    </v-btn>
                                                                                </v-btn-toggle>
                                                                            </v-col>
                                                                        </v-row>

                                                                        <!-- Size Info -->
                                                                        <v-row class="mt-2">
                                                                            <v-col cols="12">
                                                                                <v-chip small outlined class="me-2">
                                                                                    <v-icon small class="me-1">mdi-information</v-icon>
                                                                                    {{$t('DragToResize')}}
                                                                                </v-chip>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-card-text>
                                                                    <v-divider></v-divider>
                                                                    <v-card-actions class="pa-4">
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn text large @click="closeCropper(question)">
                                                                            <v-icon class="me-1">mdi-close</v-icon>
                                                                            {{$t('Cancel')}}
                                                                        </v-btn>
                                                                        <v-btn color="primary" large @click="saveCroppedImage(question)">
                                                                            <v-icon class="me-1">mdi-check</v-icon>
                                                                            {{$t('Save')}}
                                                                        </v-btn>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-dialog>

                                                            <v-row v-if="question.default">
                                                                <v-slider v-model="zoom" @change="createImage(zoom, question)"
                                                                          append-icon="mdi-magnify-plus-outline"
                                                                          prepend-icon="mdi-magnify-minus-outline"></v-slider>
                                                            </v-row>

                                                            <!--<v-file-input v-model="question.selectedFile" :label="uploadMessagePlaceHolder" accept="image/*" @change="handleFileUpload(question)" required></v-file-input>-->
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="6">
                                                            <!-- Display the preview image next to the input file element -->
                                                            <v-img v-if="question.default" :ref="'img_'+question.id" :src="question.default" height="100%" :width="defaultValue" :alt="previewMedia" class="preview-image"></v-img>
                                                        </v-col>
                                                    </v-row>
                                                </div>

                                                <!--vedioLink-->
                                                <v-text-field class="mt-3" v-if="question.questionTypeId == vedioLink" outlined v-model="question.default" hide-detail dense :label="$t('VedioLink')" />

                                                <!--NPS-->
                                                <div class="text-center" v-if="question.questionTypeId == nps">
                                                    <NPS :increaseDecrease="true" v-model="question.questionTypeParams"></NPS>
                                                </div>

                                                <!--Rating-->
                                                <template v-if="question.questionTypeId == rating">
                                                    <RatingModePicker v-model="question.questionTypeParams" :rate-length="rateLength"></RatingModePicker>
                                                </template>

                                                <!--PredefineDropdown-->
                                                <template v-if="question.questionTypeId == PredefineDropdown">
                                                    <v-row>
                                                        <v-col md="3">
                                                            <v-select class="mt-4" :rules="nameRules" v-model="question.lookupId" dense :items="itemsForDropdown(question)" :label="$t('StartWith')" outlined item-text="name" item-value="id" @change="handleSelectionChange($event)"></v-select>
                                                        </v-col>
                                                        <v-col v-if="dependentItems.length > 0" md="3">
                                                            <v-select class="mt-4" :rules="nameRules" v-model="question.questionTypeParams" dense :items="itemsForDropdownRelated(question)" :label="$t('StopWith')" outlined item-text="name" item-value="id"></v-select>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>

                                                    </v-row>
                                                </template>

                                                <!--multipleChoice checkbox dropdown-->
                                                <template v-if="question.questionTypeId == multipleChoice || question.questionTypeId == checkbox || question.questionTypeId == dropdown || question.questionTypeId == trickyQuestion">
                                                    <v-row>
                                                        <v-col cols="12" md="7">
                                                            <Draggable :list="question.options" :options="{ handle: '.opt-drag-handle', animation: 150 }" @end="onOptionDragEnd(question)" class="options-list">
                                                                <div v-for="(item, optIndex) in question.options" :key="optIndex" class="option-row d-flex align-center">
                                                                    <v-icon class="opt-drag-handle">mdi-drag</v-icon>
                                                                    <span class="option-order-badge" :title="$t('Order')">{{ optIndex + 1 }}</span>
                                                                    <v-text-field outlined v-model.lazy="item.optionAr" hide-details dense class="flex-grow-1" :label="$t('TextAr')" :rules="nameRules" />
                                                                    <v-text-field style="display:none" outlined v-model.lazy="item.optionEn" hide-details dense :label="$t('TextEn')" />
                                                                    <v-btn icon small class="option-remove" @click="removeOption(optIndex, question.options)">
                                                                        <v-icon small>mdi-close</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </Draggable>
                                                            <v-btn rounded class="mt-3" outlined @click="addOption(question)">
                                                                <v-icon size="20" class="me-2">mdi-plus-circle-outline</v-icon>{{ $t('AddOptions') }}
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </template>

                                                <template v-if="question.questionTypeId == CSAT5 || question.questionTypeId == CSAT3">

                                                    <v-row v-for="(item, optIndex) in question.options" :key="optIndex" class="mt-2">
                                                        <v-col md="1">
                                                            <v-icon size="50" :color="item.color" class="me-3">{{item.icon}}</v-icon>
                                                        </v-col>
                                                        <v-col md="2">
                                                            <v-text-field outlined v-model.lazy="item.optionAr" hide-details dense :label="$t('TextAr')" :rules="nameRules" @change="handleCopyValue('item.optionAr', 'item.optionEn')" />
                                                        </v-col>
                                                        <v-col md="2" style="display:none">
                                                            <v-text-field outlined v-model.lazy="item.optionEn" hide-details dense :label="$t('TextEn')" />
                                                        </v-col>


                                                        <v-col md="2">
                                                            <v-text-field outlined v-model.lazy="item.order" hide-details dense :label="$t('Order')" :rules="nameRules" />
                                                        </v-col>
                                                        <v-col md="1">

                                                        </v-col>
                                                    </v-row>
                                                </template>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>

                                    </v-expansion-panels>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>


                </v-form>

                <v-bottom-navigation background-color="secondary" dark shift>
                    <v-btn v-if="!isEdit" tile @click="save" color="secondary" style="height:100%" :loading="btnLoading">
                        {{ $t('Save') }}
                        <v-icon>
                            mdi-floppy
                        </v-icon>
                    </v-btn>

                    <v-btn v-if="isEdit" tile @click="save" color="secondary" style="height:100%" :loading="btnLoading">
                        {{ $t('Update') }}
                        <v-icon>
                            mdi-pencil
                        </v-icon>
                    </v-btn>

                </v-bottom-navigation>
            </v-card-text>

            <v-card-text v-else>
                <v-alert dense text type="success">
                    {{ $t('SaveSuccess') }}
                </v-alert>
                <v-card-actions class="">
                    <router-link v-slot="{ navigate }" to="/QuestionsBank" custom>
                        <v-btn role="link" tile color="primary" class="white--text" @click="navigate">
                            {{ $t('QuestionsBankListBack') }}
                        </v-btn>
                    </router-link>
                </v-card-actions>
            </v-card-text>
            <ControlPreview v-model="previewDialog" v-if="previewDialog" :questionTypeId="selectedQuestionTypeId"></ControlPreview>
        </v-card>


    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import QuestionsBankService from '@/services/QuestionsBankService.js'
    import UsersService from '@/services/UsersService.js'
    import LookupAdminService from '@/services/LookupAdminServices.js'


    import VTextField from '@/components/controls/VTextField.vue'
    import ControlPreview from '@/components/controls/ControlPreview.vue'
    import BipolarMatrix from '@/components/controls/BipolarMatrix.vue'
    import RatingModePicker from '@/components/controls/RatingModePicker.vue'
    import LikeDislike from '@/components/controls/LikeDislike.vue'
    import NPS from '@/components/controls/NPS.vue'
    import { Cropper } from 'vue-advanced-cropper'
    import 'vue-advanced-cropper/dist/style.css'

    import TextEditor from '@/components/controls/TextEditor.vue'
    import Draggable from 'vuedraggable'
    import { FormMethodEnum } from '@/helpers/constants/enumerations.js'
    import { createGuid, useStripHtml, copyValue } from '@/helpers/common.js'

    export default {
        components: {
            ControlPreview, VTextField, BipolarMatrix, RatingModePicker, LikeDislike, NPS, Cropper, TextEditor, Draggable
        },
        props: {
            isDisabled: {
                type: Boolean,
                default: false
            }
        },


        data() {
            return {
                isFirstLoad: false,
                response: null,
                nameRules: [(v) => !!v || this.$t('RequiredField')],
                questionTypes: [],
                stringFilters: [
                    'Contains',
                    'Does Not Contain',
                    'Starts With',
                    'Ends With',
                    'Is Answered',
                    'Is Not Answered',
                    'Equals',
                    'Not eEqual To',
                ],
                defaultValue: null,
                zoom: 20,
                slideValue: null,
                rateLength: 5,
                rated: 0,
                selectedQuestionTypeId: null,
                previewDialog: false,
                valid: true,
                published: false,
                outlined: true,
                loading: false,
                btnLoading: false,
                isEdit: false,
                posted: false,
                question: {
                    reference: createGuid(),
                    questionAr: '',
                    questionEn: '',
                    noteAr: '',
                    NoteEn: '',
                    questionTypeId: null,
                    orderBy: 1,
                    options: [],
                    questions: [],
                    default: null,
                    customConfiguration: null,
                    isRequired: false,
                    //questionTypeParams: 'Star',
                    optionsRating: ['Star', 'Emoji'],
                    selectedRateOption: 'Star'
                },
                shortAnswer: FormMethodEnum.ShortAnswer,
                textEditor: FormMethodEnum.TextEditor,
                checkbox: FormMethodEnum.Checkboxes,
                multipleChoice: FormMethodEnum.MultipleChoice,
                dropdown: FormMethodEnum.Dropdown,
                trickyQuestion: FormMethodEnum.TrickyQuestion,
                rating: FormMethodEnum.Rating,
                CSAT5: FormMethodEnum.CSAT5,
                CSAT3: FormMethodEnum.CSAT3,
                number: FormMethodEnum.number,
                yesNo: FormMethodEnum.YesNo,
                date: FormMethodEnum.Date,
                textArea: FormMethodEnum.TextArea,
                bipolarMatrix: FormMethodEnum.BipolarMatrix,
                PredefineDropdown: FormMethodEnum.PredefineDropdown,
                image: FormMethodEnum.Image,
                vedioLink: FormMethodEnum.VedioLink,
                nps: FormMethodEnum.NPS,
                lookups: [],
                selectedItem: [],
                uploadMessagePlaceHolder: this.$t('Upload'),
                selectedFile: null,
                previewMedia: this.$t('Preview'),
                hasUpdatePublishedPermission: false,
                dependentItems: [],
                cardTitle: this.$t('AddQuestion'),
                show: true,
                params: {
                    token: '123456798',
                    name: 'avatar'
                },
                headers: {
                    smail: '*_~'
                },
                imgDataUrl: ''

            }
        },

        created() {
            this.isFirstLoad = true
            this.getquestionTypes()
            if (this.$route.query.id) {
                this.isEdit = true
                this.loadQuestion(this.$route.query.id)

            }
            this.loadLookups()

        },
        
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
            itemsForDropdown() {
                return (currentQuestion) => {
                    LookupAdminService.listSurveyLookupItems(currentQuestion.lookupId)
                        .then((res) => {
                            currentQuestion.lookupoptions = []
                            res.data.forEach((el) => {
                                currentQuestion.lookupoptions.push({ id: el.id.toString(), name: el.name })
                            })
                        })
                        .catch((error) => {
                            //this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => {
                            //this.loading = false
                        })
                    var language = this.getLanguage
                    return this.lookups.map(item => ({ id: item.id, name: language == 'ar' ? item.nameAr : item.nameEn }))
                }
            },
            itemsForDropdownRelated() {
                return (currentQuestion) => {
                    LookupAdminService.listSurveyLookupItems(currentQuestion.lookupId)
                        .then((res) => {
                            currentQuestion.lookupoptions = []
                            res.data.forEach((el) => {
                                currentQuestion.lookupoptions.push({ id: el.id.toString(), name: el.name })
                            })
                        })
                        .catch((error) => {
                            //this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => {
                            //this.loading = false
                        })
                    var language = this.getLanguage
                    return this.dependentItems.map(item => ({ id: item.id.toString(), name: language == 'ar' ? item.nameAr : item.nameEn }))
                }
            },
            itemsForAllDropDown() {
                var language = this.getLanguage
                var all = []
                this.lookups.forEach(item => {
                    all.push({ id: item.id.toString(), name: language == 'ar' ? item.nameAr : item.nameEn })
                })
                this.dependentItems.forEach(item => {
                    all.push({ id: item.id.toString(), name: language == 'ar' ? item.nameAr : item.nameEn })
                })
                return all
            },

        },

        methods: {
            changeQuestionType(question, event) {
                this.selectedMethod = event
                question.questionTypeId = event
                question.questionTypeParams = ''
                if (question.questionTypeId == this.CSAT5) {
                    this.addCSAT5Options(question)
                }
                else if (question.questionTypeId == this.CSAT3) {
                    this.addCSAT3Options(question)
                }
            },
            loadDependentItemsForEdit() {

                if (this.question.questionTypeId === this.PredefineDropdown) {
                    this.loadDependentItems(this.question.lookupId)
                }

            },

            handleCopyValue(sourcePath, targetPath) {
                copyValue(sourcePath, targetPath, this, false)
            },

            getquestionTypes() {
                LookupAdminService.listQuestionTypeItems().then((res) => {
                    this.questionTypes = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            CheckRatingOption() {
                this.question.questionTypeParams = this.question.selectedRateOption
            },
            addCSAT5Options(question) {
                question.options = []
                let option1 = { optionAr: 'راضٍ جداً', optionEn: 'Very Satisfied', order: 1, icon: 'mdi-emoticon-outline', color: '#14573A' }
                question.options.push(option1)
                let option2 = { optionAr: 'راضٍ', optionEn: 'Satisfied', order: 2, icon: 'mdi-emoticon-happy-outline', color: '#1B8354' }
                question.options.push(option2)
                let option3 = { optionAr: 'محايد', optionEn: 'Neutral', order: 3, icon: 'mdi-emoticon-neutral-outline', color: '#FEC84B' }
                question.options.push(option3)
                let option4 = { optionAr: 'غير راضٍ', optionEn: 'Not Satisfied', order: 4, icon: 'mdi-emoticon-sad-outline', color: '#F04438' }
                question.options.push(option4)
                let option5 = { optionAr: 'غير راضٍ مطلقًا', optionEn: 'No Satisfied at all', order: 5, icon: 'mdi-emoticon-dead-outline', color: '#B42318' }
                question.options.push(option5)
            },
            addCSAT3Options(question) {
                question.options = []
                let option1 = { optionAr: 'راضٍ', optionEn: 'Satisfied', order: 1, icon: 'mdi-emoticon-happy-outline', color: '#1B8354' }
                question.options.push(option1)
                let option2 = { optionAr: 'محايد', optionEn: 'Neutral', order: 2, icon: 'mdi-emoticon-neutral-outline', color: '#FEC84B' }
                question.options.push(option2)
                let option3 = { optionAr: 'غير راضٍ', optionEn: 'Not Satisfied', order: 3, icon: 'mdi-emoticon-sad-outline', color: '#F04438' }
                question.options.push(option3)
            },
            addOption() {
                let option = { optionAr: '', optionEn: '', order: this.question.options.length + 1 }
                this.question.options.push(option)
                this.inputTextAr = ''
                this.inputTextEn = ''
            },
            removeOption(index, options) {
                options.splice(index, 1)
                // Keep `order` contiguous — it is display-only now (position badge) and driven by drag/remove
                options.forEach((opt, i) => { opt.order = i + 1 })
            },
            onOptionDragEnd(question) {
                // The rendered form sorts choices by `order`, so a drag must renumber it
                if (Array.isArray(question.options)) {
                    question.options.forEach((opt, i) => { opt.order = i + 1 })
                }
            },
            loadLookups() {
                LookupAdminService.listSurveyLookups().then((res) => {
                    this.lookups = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            handleSelectionChange(selected) {
                this.question.lookupId = selected
                this.predefineDropdownItemsPage()
                this.loadDependentItems(selected)
                LookupAdminService.listSurveyLookupItems(this.question.lookupId)
                    .then((res) => {
                        this.question.lookupoptions = []
                        res.data.forEach((el) => {
                            this.question.lookupoptions.push({ id: el.id.toString(), name: el.name })
                        })
                    })
                    .catch((error) => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
            },
            loadDependentItems(id) {
                LookupAdminService.listSurveyLookupsByParentId(id).then((res) => {
                    this.dependentItems = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            scrollToFirstInvalidField() {
                // Use nextTick to ensure the DOM has been updated with validation errors
                this.$nextTick(() => {
                    // Find the first element with error class
                    const errorElement = document.querySelector('.v-input.error--text, .v-text-field.error--text, .error--text')

                    if (errorElement) {
                        // If the element is in a collapsed section, expand it first
                        if (!this.showAdditionalFields) {
                            // Check if the error element is within the collapsible section
                            const collapsibleSection = errorElement.closest('.v-expand-transition')
                            if (collapsibleSection) {
                                this.showAdditionalFields = true
                                // Wait for the expansion animation to complete before scrolling
                                this.$nextTick(() => {
                                    this.performScroll(errorElement)
                                })
                                return
                            }
                        }

                        this.performScroll(errorElement)
                    }
                })
            },
            performScroll(element) {
                // Scroll to the element with smooth behavior and offset for better visibility
                const yOffset = -100 // Offset from the top of the viewport
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset

                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                })

                // Focus the input field if possible
                const input = element.querySelector('input, textarea, select')
                if (input) {
                    setTimeout(() => {
                        input.focus()
                    }, 500) // Wait for scroll animation
                }
            },
            save() {
                if (!this.$refs.surveyForm.validate()) {
                    //this.$root.$notification(this.$t('AddNameError'), 'error')
                    this.scrollToFirstInvalidField()
                    return
                }
                else {
                    this.loading = true
                    // this.question.questionAr = useStripHtml(this.question.questionAr)
                    // this.question.questionEn = useStripHtml(this.question.questionEn)

                    QuestionsBankService.addQuestion(this.question).then((res) => {
                        this.$refs.surveyForm.resetValidation()
                        this.$refs.surveyForm.reset()
                        this.posted = true
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            validate() {
                let valid = true
                if (this.$refs.surveyForm.validate()) {

                    valid = true
                }
                else { valid = false }
                return valid
            },
            loadQuestion(questionId) {
                this.loading = true
                QuestionsBankService.loadQuestion(questionId).then((res) => {
                    this.question = res.data
                    this.question.id = questionId
                    this.loadDependentItemsForEdit()
                    let currentQuestion = this.question
                    if (currentQuestion && currentQuestion.questionTypeId == this.PredefineDropdown) {
                        this.predefineDropdownItemsPage()

                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            toggleShow() {
                this.show = !this.show
            },
            onImageFileChange(event, question) {
                const file = event.target.files[0]
                if (file && file.type.startsWith('image/')) {
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        // Initialize cropper properties if not exist
                        if (!question.cropperImage) {
                            this.$set(question, 'cropperImage', '')
                            this.$set(question, 'showCropper', false)
                            this.$set(question, 'cropperZoom', 0)
                            this.$set(question, 'rotationAngle', 0)
                        }
                        // Set the image and show cropper
                        question.cropperImage = e.target.result
                        question.showCropper = true
                        question.cropperZoom = 0
                        question.rotationAngle = 0
                    }
                    reader.readAsDataURL(file)
                }
            },
            closeCropper(question) {
                question.showCropper = false
                question.cropperImage = null
                question.cropperZoom = 0
                question.rotationAngle = 0
                // Reset file input
                const fileInput = this.$refs['fileInput_' + question.id]
                if (fileInput && fileInput[0]) {
                    fileInput[0].value = ''
                }
            },
            saveCroppedImage(question) {
                const cropperRef = this.$refs['cropper_' + question.id]
                if (cropperRef && cropperRef[0]) {
                    const { canvas } = cropperRef[0].getResult()
                    if (canvas) {
                        question.default = canvas.toDataURL('image/png', 0.9)
                        this.imgDataUrl = question.default
                        this.closeCropper(question)
                    }
                }
            },
            onZoomChange(question) {
                const cropperRef = this.$refs['cropper_' + question.id]
                if (cropperRef && cropperRef[0]) {
                    cropperRef[0].zoom(question.cropperZoom)
                }
            },
            rotateImage(question, angle) {
                const cropperRef = this.$refs['cropper_' + question.id]
                if (cropperRef && cropperRef[0]) {
                    cropperRef[0].rotate(angle)
                }
            },
            flipImageHorizontal(question) {
                const cropperRef = this.$refs['cropper_' + question.id]
                if (cropperRef && cropperRef[0]) {
                    cropperRef[0].flip(true, false)
                }
            },
            flipImageVertical(question) {
                const cropperRef = this.$refs['cropper_' + question.id]
                if (cropperRef && cropperRef[0]) {
                    cropperRef[0].flip(false, true)
                }
            },
            resetCropper(question) {
                const cropperRef = this.$refs['cropper_' + question.id]
                if (cropperRef && cropperRef[0]) {
                    cropperRef[0].reset()
                    question.cropperZoom = 0
                    question.rotationAngle = 0
                }
            },
            cropSuccess(question, imgDataUrl) {

                this.imgDataUrl = imgDataUrl
                question.default = imgDataUrl
                console.log('-------- crop success --------', field)
            },
            cropUploadSuccess(jsonData, field) {
                console.log('-------- upload success --------')
                console.log(jsonData)
                console.log('field: ' + field)
            },
            cropUploadFail(status, field) {
                console.log('-------- upload fail --------')
                console.log(status)
                console.log('field: ' + field)
            },
            handleFileUpload(question) {
                if (question.selectedFile) {
                    const file = question.selectedFile
                    if (file) {
                        const reader = new FileReader()
                        reader.onload = () => {

                            question.default = reader.result
                            console.log('-------- crop success --------', question.default)
                        }
                        reader.readAsDataURL(file)
                    }
                }
            },
            predefineDropdownItemsPage() {
                LookupAdminService.listSurveyLookupItems(this.question.lookupId)
                    .then((res) => {
                        this.question.lookupoptions = []
                        res.data.forEach((el) => {
                            this.question.lookupoptions.push({ id: el.id.toString(), name: el.name })
                        })
                    })
                    .catch((error) => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
            },


            zoomOut() {
                this.defaultValue = (this.defaultValue - 10) || 0 + '%'
            },
            zoomIn() {
                this.defaultValue = (this.defaultValue + 10) || 100 + '%'
            },

            createImage(value) {
                this.defaultValue = value + '%'
                var vImgComponent = this.$refs['img_' + this.question.id][0] // Assuming 'img_' + question.id is the ref name
                setTimeout(function () {
                    var div = vImgComponent.$el.querySelector('.v-image__image')
                    var style = getComputedStyle(vImgComponent.$el)
                    var imgheight = parseInt(style.height)
                    var imgwidth = parseInt(style.width)
                    // Create a new Image object
                    var imageLoader = new Image()
                    imageLoader.width = imgwidth
                    imageLoader.height = imgheight
                    // Attach the onload event listener to the Image object
                    imageLoader.onload = function () {
                        // Now, the image is fully loaded
                        var imgHeight = imgheight
                        var imgWidth = imgwidth
                        // Create a canvas element
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')

                        // Set canvas dimensions
                        canvas.width = imgWidth
                        canvas.height = imgHeight

                        // Draw the image onto the canvas
                        ctx.drawImage(imageLoader, 0, 0, imgwidth, imgheight)

                        // Get the Data URL representation of the canvas
                        var dataUrl = canvas.toDataURL('image/jpeg')

                        // Update question.default with the Data URL
                        this.question.default = dataUrl
                    }

                    // Set the src attribute of the Image object (start loading the background image)
                    imageLoader.src = getComputedStyle(div).backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2')
                }, 500)
                // Access the underlying div element within v-img


            }
        },
    }
</script>

<style>
    .v-expansion-panel-header {
        border-bottom: 2px solid green;
        background: #f7f7f7;
        height: 40px
    }

    .preview-image {
        width: 150px; /* Adjust the size as needed */
        height: 150px; /* Adjust the size as needed */
    }

    .cropper-wrapper {
        height: 500px;
        background: #DDD;
    }

    /* --- Question options list (drag-and-drop) --- */
    .options-list { display: flex; flex-direction: column; gap: 8px; }
    .option-row {
        gap: 10px;
        border: 1px solid #e0e6e3;
        border-radius: 8px;
        background: #fff;
        padding: 8px 10px;
        transition: box-shadow .15s ease, border-color .15s ease;
    }
    .option-row:hover { border-color: #9bb3aa; box-shadow: 0 1px 6px rgba(27, 110, 83, .12); }
    .option-row.sortable-ghost { opacity: .45; background: #eef4f1; border-style: dashed; }
    .opt-drag-handle { cursor: grab; color: #9bb3aa !important; }
    .option-row:hover .opt-drag-handle { color: #1b6e53 !important; }
    .option-order-badge {
        min-width: 26px;
        height: 26px;
        border-radius: 50%;
        background: #eef4f1;
        color: #1b6e53;
        font-weight: 600;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        user-select: none;
    }
    .option-remove .v-icon { color: #b0574f; }
</style>